import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  // Input,
  Label,
} from "reactstrap";
import { Formik, Field, Form } from "formik";
import { Uploader } from "rsuite";
// import Select from "react-select";
// import CustomSelectInput from "../../../../../../components/common/CustomSelectInput";
import IntlMessages from "../../../../../../helpers/IntlMessages";

import { Product, UploaderImage } from "../../../../../../api/Api";

export default class AddConstant extends Component {
  state = {
    loading: false,
    picture: "",
    file: "",
    imagesId: [],
    initialValues: {
      name_Fa: "",
      name_En: "",
      description: "",
      addImage: "",
    },
  };

  handleChange = async ({ target }) => {
    try {
      let file = target.files[0],
        src = target.value;
      var reader = new FileReader();
      reader.onloadend = () => {
        this.setState({
          file,
          imagePreviewUrl: reader.result,
        });
      };
      reader.readAsDataURL(file);

      this.setState({ file, src });
    } catch (error) {}
  };

  handleSubmit = async (values, { resetForm, setSubmitting, setValues }) => {
    this.setState({ loading: true });
    try {
      let newValues = {
        ...values,
        addImage: this.state.imagesId,
      };
      console.log(this.state.imagesId);
      await Product.addProduct(newValues);

      //closing addNew Component
      this.props.toggleModal();

      //fetching data from dataBase
      this.props.dataListRender();

      // if (!this.state.isNew) {
      //   Swal.close();
      // }
      resetForm();
    } catch (error) {
      console.error(error);
      // toast(error.response.data.message);
    }
    this.setState({ loading: false });
  };

  handleChangeAlbum = async ({ target, ...e }) => {
    try {
      let myArray = [];

      for (const key in e) {
        myArray.push(e[key].blobFile);
      }

      const { data } = await UploaderImage.addImages(myArray);
      let imagesId = [];
      data.data.forEach((element) => {
        imagesId.push(element.id);
      });

      this.setState({ myArray, imagesId });
    } catch (error) {}
  };
  render() {
    return (
      <>
        <Modal
          isOpen={this.props.modalOpen}
          toggle={this.props.toggleModal}
          wrapClassName="modal-right"
          backdrop="static"
        >
          {this.state.loading ? <div className="loading" /> : ""}
          <ModalHeader toggle={this.props.toggleModal}>
            <IntlMessages id="ثبت محصول" />
          </ModalHeader>
          <ModalBody>
            <Formik
              initialValues={this.state.initialValues}
              // validationSchema={this.ValidationSchema}
              onSubmit={this.handleSubmit}
            >
              {(props) => (
                <Form className="form" onSubmitCapture={props.handleSubmit}>
                  <Label className="mt-4">
                    <IntlMessages id="تیتر به فارسی " />
                  </Label>
                  <Field
                    name="name_Fa"
                    placeholder="تیتر به فارسی  "
                    className="form-control"
                    type="text"
                    required
                  />
                  <Label className="mt-4">
                    <IntlMessages id="تیتر به انگلیسی " />
                  </Label>
                  <Field
                    name="name_En"
                    placeholder="تیتر به انگلیسی  "
                    className="form-control"
                    type="text"
                    required
                  />

                  <Label className="mt-4">
                    <IntlMessages id="description-moti" />
                  </Label>
                  <Field
                    name="description"
                    placeholder="توضیحات  "
                    className="form-control"
                    type="text"
                    required
                  />

                  <div style={{ position: "relative" }}>
                    <Label className="mt-4">
                      <IntlMessages id="تصاویر" />
                    </Label>
                    <Uploader
                      style={{ height: "20px", marginBottom: "30px" }}
                      name="photoAlbum"
                      placeholder="عکس"
                      className="custom-file-input"
                      type="file"
                      multiple
                      onChange={(e) => this.handleChangeAlbum(e)}
                      accept="image/*"
                    />

                    <button
                      style={{
                        position: "absolute",
                        top: "50px",
                        left: "1px",
                        width: "325px",
                        background: "white",
                        height: "45px",
                      }}
                      type="button"
                    >
                      اپلود تصویر
                    </button>
                  </div>

                  {/* <CustomInput
                    name="picture"
                    placeholder="عکس  "
                    type="file"
                    accept="image/*"
                    onChange={(e) => this.handleChange(e)}
                    id="exampleCustomFileBrowser1"
                    // name="customFile"
                  /> */}
                  {/* {this.state.imagePreviewUrl ? (
                    <img
                      alt=""
                      style={{ width: "300px", marginTop: "20px" }}
                      src={this.state.imagePreviewUrl}
                    />
                  ) : (
                    ""
                  )} */}
                  <ModalFooter>
                    <div style={{ marginTop: "100px" }}>
                      <Button
                        color="secondary"
                        outline
                        onClick={this.props.toggleModal}
                      >
                        <IntlMessages id="pages.cancel" />
                      </Button>
                      <Button color="primary" type="submit">
                        <IntlMessages id="pages.submit" />
                      </Button>
                    </div>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </ModalBody>

          {/* <ModalHeader toggle={toggleModal}>
          <IntlMessages id="pages.add-new-modal-title" />
        </ModalHeader>
        <ModalBody>
          <Label className="mt-4">
            <IntlMessages id="pages.name" />
          </Label>
          <Input />
          <Label className="mt-4">
            <IntlMessages id="pages.price" />
          </Label>
          <Input />
          <Label className="mt-4">
            <IntlMessages id="pages.duration" />
          </Label>
          <Input />
          <Label className="mt-4">
            <IntlMessages id="pages.category" />
          </Label>
          <Select
            components={{ Input: CustomSelectInput }}
            className="react-select"
            classNamePrefix="react-select"
            name="form-field-name"
            options={categories}
          />
          <Label className="mt-4">
            <IntlMessages id="pages.description" />
          </Label>
          <Input type="textarea" name="text" id="exampleText" />
          <Label className="mt-4">
            <IntlMessages id="pages.status" />
          </Label>
          <CustomInput
            type="radio"
            id="exCustomRadio"
            name="customRadio"
            label="ON HOLD"
          />
          <CustomInput
            type="radio"
            id="exCustomRadio2"
            name="customRadio"
            label="PROCESSED"
          />
        </ModalBody> */}
          {/* <ModalFooter>
          <Button color="secondary" outline onClick={toggleModal}>
            <IntlMessages id="pages.cancel" />
          </Button>
          <Button color="primary" onClick={toggleModal}>
            <IntlMessages id="pages.submit" />
          </Button>{" "}
        </ModalFooter> */}
        </Modal>
      </>
    );
  }
}
